import { Injectable } from '@angular/core';
import { AppStateService } from '@modules/core/services/app-state.service';
import { LoggingService } from '@modules/shared/services/logging.service';
import { firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggingHelperService {
  constructor(
    private readonly appStateService: AppStateService,
    private readonly loggingService: LoggingService
  ) {}

  async logPageViewCount(name?: string, url?: string, properties?: { [key: string]: any }) {
    this.loggingService.logPageView(name, url, properties);

    const trafficAreas = await firstValueFrom(this.appStateService.getSelectedGaragesState().pipe(
      map(garages => garages.map(g => g.trafficAreaName).filter((val, idx, arr) => arr.indexOf(val) === idx))
    ));

    for (const trafficArea of trafficAreas) {
      this.loggingService.logMetric('PageView.CountPerTrafficArea', 1, {
        'Category': 'PageView',
        'Subcategory': name,
        'TrafficArea': trafficArea,
      });
    }
  }
}
